import React, { useEffect, useState } from "react";
import { makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";

const WithdrawalRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [transactionId, setTransactionId] = useState("");

  // API Se Data Mangwana
  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await makeRequestAuth("post", "/admin/getWithdrawalRequests", { status: "pending" });
      if (res.error === false) {
        setRequests(res.data);
      } else {
        showErrorToast(res.message || "Failed to fetch requests");
      }
    } catch (error) {
      showErrorToast("Server error fetching requests");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  // Approve Modal Kholna
  const handleOpenModal = (req) => {
    setSelectedRequest(req);
    setTransactionId("");
    setShowModal(true);
  };

  // Approve Request API Call
  const handleApprove = async () => {
    if (!transactionId) return showErrorToast("Transaction ID is required");
    
    try {
      const res = await makeRequestAuth("post", "/admin/approveWithdrawal", {
        requestId: selectedRequest._id,
        transactionId: transactionId
      });
      if (res.error === false) {
        showSuccessToast("Withdrawal Approved Successfully!");
        setShowModal(false);
        fetchRequests(); // Table refresh karein
      } else {
        showErrorToast(res.message || "Failed to approve");
      }
    } catch (error) {
      showErrorToast("Server error during approval");
    }
  };

  return (
    <div className="p-6 bg-slate-50 min-h-screen">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Agent Withdrawal Requests</h1>
        <p className="text-slate-500">Pending payout requests from agents.</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-slate-500">Loading requests...</div>
        ) : requests.length === 0 ? (
          <div className="p-8 text-center text-slate-500 font-medium">No pending requests found.</div>
        ) : (
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-100 text-slate-600 text-sm">
                <th className="p-4 font-bold border-b border-slate-200">Agent Name</th>
                <th className="p-4 font-bold border-b border-slate-200">Phone</th>
                <th className="p-4 font-bold border-b border-slate-200">Amount</th>
                <th className="p-4 font-bold border-b border-slate-200">Bank Details / UPI</th>
                <th className="p-4 font-bold border-b border-slate-200">Date</th>
                <th className="p-4 font-bold border-b border-slate-200 text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((req) => (
                <tr key={req._id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="p-4 font-medium text-slate-800">{req.agentId?.name || "N/A"}</td>
                  <td className="p-4 text-slate-600">{req.agentId?.phone || "N/A"}</td>
                  <td className="p-4 font-bold text-blue-600">₹{req.amount}</td>
                  <td className="p-4 text-slate-600">{req.bankDetails}</td>
                  <td className="p-4 text-sm text-slate-500">
                    {new Date(req.createdAt).toLocaleDateString("en-IN")}
                  </td>
                  <td className="p-4 text-right">
                    <button
                      onClick={() => handleOpenModal(req)}
                      className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-sm transition-all"
                    >
                      Approve
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Approval Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl w-[400px] p-6 shadow-xl">
            <h2 className="text-lg font-bold text-slate-800 mb-1">Approve Withdrawal</h2>
            <p className="text-sm text-slate-500 mb-4">
              Agent: <span className="font-bold">{selectedRequest?.agentId?.name}</span> <br/>
              Amount: <span className="font-bold text-blue-600">₹{selectedRequest?.amount}</span>
            </p>

            <div className="mb-5">
              <label className="text-sm font-bold text-slate-700 block mb-2">Transaction / UTR ID</label>
              <input
                type="text"
                placeholder="Enter bank transaction ID..."
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:outline-none focus:border-blue-500"
              />
            </div>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg font-medium transition-all"
              >
                Cancel
              </button>
              <button
                onClick={handleApprove}
                className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg font-bold transition-all shadow-sm"
              >
                Confirm Payment
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawalRequests;
